// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1jYtc","location":"Header_location__3ih9W"};